import * as Sentry from '@sentry/react'
// import { Integrations } from '@sentry/tracing'
import { getClientEnv } from './common'

const environment = getClientEnv()
const version = 'xp-digital-aftersale@' + require('../../package.json').version

const SentryInit = (devNeed = false) => {
  if (!devNeed && environment === 'dev') {
    return
  }

  Sentry.init({
    dsn: 'https://dbd1d36f58b844759479853d65343d46@front-monitor.xiaopeng.com/5',
    environment,
    release: version,
    // integrations: [new Integrations.BrowserTracing()],
    // tracesSampleRate: 1.0,
    debug: environment === 'dev',
  })
}

export default SentryInit
